<!-- <h2 mat-dialog-title> <mat-icon mat-dialog-close>close</mat-icon> </h2> -->
close h2
<div class="camera-container">
  <div *ngIf="!imageCaptured"  >
    <webcam  [trigger]="triggerObservable" (imageCapture)="handleImage($event)" *ngIf="showWebcam"
             [allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable" [videoOptions]="videoOptions" (cameraSwitched)="cameraWasSwitched($event)"
             (initError)="handleInitError($event)"></webcam>
    <br/>

  </div>

  <h4 *ngIf="errors.length > 0">{{'MESSAGES'| translate}}:</h4>
  <ul *ngFor="let error of errors">
    <li>{{error | json}}</li>
  </ul>
</div>
<div class="webcam-btn" *ngIf="!imageCaptured">
  <button class="actionBtn" (click)="triggerSnapshot();" title="Take Picture">{{'CAPTURE'| translate}}</button>
  <button class="actionBtn" (click)="showNextWebcam(true);" title="Switch Camera">{{'SWITCH_CAMERA'| translate}}</button>
</div>
<div class="snapshot" *ngIf="imageCaptured">
  <img [src]="webcamImage.imageAsDataUrl" />
</div>
<div class="webcam-btn" *ngIf="imageCaptured">
  <button class="actionBtn" (click)="uploadPicture();">{{'UPLOAD'| translate}}</button>
  <button class="actionBtn" (click)="retake()" >{{'RETAKE'| translate}}</button>
</div>


